module.exports = __webpack_public_path__ + "static/media/creativeschool_3_t.917851da.jpg";